<template>
  <span />
</template>

<script>

export default {
  mounted () {
    this.$router.replace({ name: 'operative-company' });
  },
};

</script>
